import axios from 'axios'
import { loading, setSessionId } from '@/util/util.js'
import router from '../router'
import store from '../store/store'

let disableLoading = false

//http request拦截器
axios.interceptors.request.use(
  config => {
    config.headers['source'] = 'venus';
    // 特定请求不显示loading
    /&method=virgift.office.userinfo/.test(config.data) ? disableLoading = true : disableLoading = false
    if (!disableLoading) loading.show();
    return config;
  },
  err => {
    return Promise.reject(err);
  });

//http response拦截器
axios.interceptors.response.use(
  response => {
    if (response.data && response.data.errCode === 305) { //请重新登录
      store.commit('setLoginAccount', null);
    } else if (response.data && response.data.errCode === 0) {
      if (response.data.sessionid) {
        setSessionId(response.data.sessionid);
      }
    }
    if (!disableLoading) loading.hide();
    return response;
  },
  error => {
    if (!disableLoading) loading.hide();
  }
)

export default axios;



// WEBPACK FOOTER //
// ./src/axios/axios.js